// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"Dk-z","landingPageVideo":"Ek-z","play":"Fk-z","iframeVideo":"Gk-z","playHidden":"Hk-z","fullwidth":"Ik-z"};